import React from 'react';
import { Box, Typography, Container, Paper, useTheme } from '@mui/material';
import { GradientText } from '../components/ui/GradientText';
import { DemoRequestForm } from '../components/forms/DemoRequestForm';
import { WhatToExpectSection } from '../components/sections/WhatToExpectSection';
import { DEMO_CONTENT } from '../constants';

/**
 * Demo request page
 * Contains hero, demo request form, and what to expect section
 */
export const DemoPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 5, md: 8 },
          background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <GradientText
            variant="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2.5rem', md: '3rem' },
            }}
          >
            {DEMO_CONTENT.hero.title}
          </GradientText>

          <Typography
            variant="h5"
            color="text.secondary"
            sx={{
              fontWeight: 400,
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            {DEMO_CONTENT.hero.subtitle}
          </Typography>
        </Container>
      </Box>

      {/* Demo Form Section */}
      <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper' }}>
        <Container maxWidth="md">
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 3,
              backgroundColor: (theme) =>
                theme.palette.mode === 'light' ? '#FFFFFF' : 'rgba(255, 255, 255, 0.05)',
              boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
              }}
            >
              {DEMO_CONTENT.formTitle}
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                mb: 4,
                textAlign: 'center',
              }}
            >
              {DEMO_CONTENT.formDescription}
            </Typography>

            <DemoRequestForm />
          </Paper>
        </Container>
      </Box>

      {/* What to Expect Section */}
      <WhatToExpectSection compact />
    </Box>
  );
};
